import { LineChart as MUILineChart } from '@mui/x-charts';
import { useLineChart } from '@views/pages/Dashboard/components/Charts/LineChart/hooks';
import { FC } from 'react';
import { TaskLabelType } from '@views/pages/Dashboard/AdminView/hooks/useTaskCharts.ts';
import {
  ChartNoResultPlaceholder,
  LineChartDataItem,
} from '@views/pages/Dashboard/components';

const stackStrategy = {
  stack: 'total',
  area: true,
  stackOffset: 'none', // To stack 0 on top of others
} as const;

const customize = {
  legend: { hidden: true },
  margin: { top: 5, bottom: 40, left: 45, right: 50 },
};

interface LineChartProps {
  chartData: LineChartDataItem[];
  labelKeys: { [key: string]: TaskLabelType };
  taskYAxisMaxValue: number;
  height?: number;
}

export const LineChart: FC<LineChartProps> = ({
  chartData,
  labelKeys,
  taskYAxisMaxValue,
  height = 300,
}) => {
  const { xAxisValues } = useLineChart({
    chartData,
  });

  return (
    <>
      {chartData.length > 0 ? (
        <MUILineChart
          xAxis={[
            {
              data: xAxisValues,
              scaleType: 'point',
              tickLabelInterval: () => true,
              height: 30,
              tickSpacing: 100,
            },
          ]}
          yAxis={[
            {
              min: 0,
              max: taskYAxisMaxValue + 3,
            },
          ]}
          series={Object.keys(labelKeys).map(key => ({
            dataKey: key,
            label: labelKeys[key].label,
            color: labelKeys[key].color,
            showMark: true,
            curve: 'linear',
            labelMarkType: 'square',
            ...stackStrategy,
          }))}
          dataset={chartData}
          height={height}
          sx={{
            '.MuiAreaElement-root': {
              filter: 'none',
            },
          }}
          slotProps={{
            legend: {
              position: { vertical: 'bottom', horizontal: 'center' },
              direction: 'horizontal',
            },
          }}
          {...customize}
        />
      ) : (
        <ChartNoResultPlaceholder />
      )}
    </>
  );
};
